import { useMemo } from 'react';
import dayjs from 'dayjs';
import { DAYJS_FORMAT } from '@/constant';
import cx from './index.module.scss';

export const getLastSevenDays = () => {
  const dates: string[] = [];
  const showDates: string[] = [];
  for (let i = 0; i < 7; i++) {
    const date = dayjs().subtract(i, 'day').format(DAYJS_FORMAT.DATE);
    const showDate = dayjs().subtract(i, 'day').format('YYYY年M月D日');
    dates.push(date);
    showDates.push(showDate);
  }
  return dates.map((item, index) => {
    let showText = item;
    if (index === 0) {
      showText = '今天';
    } else if (index === 1) {
      showText = '昨天';
    } else {
      showText = showDates[index];
    }
    return {
      date: item,
      showText,
    };
  });
};

const WeekTimeSelect = ({
  currentDate,
  handleDateChange,
}: {
  currentDate: string;
  handleDateChange: (date: string) => void;
}) => {
  const weekList = useMemo(() => {
    return getLastSevenDays();
  }, []);

  return (
    <div className={cx('container')}>
      {weekList.map(({ date, showText }) => (
        <div
          key={date}
          className={cx('card', { 'card-selected': currentDate === date })}
          onClick={() => handleDateChange(date)}>
          {showText}
        </div>
      ))}
    </div>
  );
};

export default WeekTimeSelect;
